<pas-navbar>
  <pas-nav-element
    [destination]="'home'"
    [isMain]="true"
    [class.disabled]="true"
    icon="apps"
    text="{{ 'APP_TITLE' | translate }}"></pas-nav-element>

  <pas-nav-element
    [destination]="'recourseBooking'"
    (click)="onNavigateRecourseBooking()"
    icon="apps"
    text="{{ 'RECOURSE_BOOKING_TAB' | translate }}"></pas-nav-element>

  @if (recourseCampaignTabVisible()) {
    <pas-nav-element
      [destination]="'recourseCampaign'"
      (click)="onNavigateRecourseCampaign()"
      icon="format_list_bulleted"
      text="{{ 'RECOURSE_CAMPAIGN_TAB' | translate }}"></pas-nav-element>
  }

  @if (approvalTabVisible()) {
    <pas-nav-element
      [destination]="'approval'"
      (click)="onNavigateApproval()"
      icon="done_all"
      text="{{ 'APPROVAL_TAB' | translate }}"></pas-nav-element>
  }

  @if (afterSalesTabVisible()) {
    <pas-nav-element
      [destination]="'afterSales/tabs'"
      (click)="onNavigateAfterSales()"
      icon="point_of_sale"
      text="{{ 'AFTER_SALES_TAB' | translate }}"></pas-nav-element>
  }

  @if (fieldMasterDataTabVisible()) {
    <pas-nav-element
      [destination]="'fieldMasterData'"
      (click)="onNavigateSupplierParts()"
      icon="view_quilt"
      text="{{ 'FIELD_MASTER_DATA_TAB' | translate }}"></pas-nav-element>
  }
  <!-- Temporary turned off
  @if (claimRecourseTabVisible()) {
    <pas-nav-element
      [destination]="'claimRecourse'"
      (click)="onNavigateClaimRecourse()"
      icon="next_week"
      text="{{ 'RECOURSE_CLAIM_TAB' | translate }}"></pas-nav-element>
  }
  -->

  <pas-nav-userarea [userId]="user?.ppnUserId ? user.ppnUserId : ''" icon="person_outline">
    <pas-nav-user-element icon="settings" text="Settings" destination="#"></pas-nav-user-element>
    <pas-nav-user-element (click)="onLogout()" icon="power_settings_new" text="Log out"></pas-nav-user-element>
  </pas-nav-userarea>
</pas-navbar>
<pas-notifications></pas-notifications>
<pas-confirmation></pas-confirmation>

<main>
  <tur-content></tur-content>
  <ngx-spinner [fullScreen]="true" type="ball-clip-rotate" bdColor="rgba(0,0,0,0.5)" size="large" color="#f40000">
    <p style="color: white"></p>
  </ngx-spinner>
</main>

<tur-sticky-footer
  [beInfos]="'BE: ' + backendVersion + ' - ' + buildDate"
  [uiInfos]="'UI: ' + uiVersion + ' - ' + uiBuildDate"></tur-sticky-footer>

<app-spinner [isActive]="isSpinnerActive$ | async"></app-spinner>
